import { useState } from "react";
import { Mail, MessageSquare, Copy, Check } from "lucide-react";

interface MessageVariant {
  label: string;
  subject?: string;
  body: string;
}

interface MessageComposeData {
  kind: "email" | "textMessage" | "other";
  summary_title: string;
  variants: MessageVariant[];
}

interface Props {
  data: MessageComposeData;
}

export default function MessageCompose({ data }: Props) {
  const [activeVariant, setActiveVariant] = useState(0);
  const [copied, setCopied] = useState(false);

  const variant = data.variants[activeVariant];
  const isEmail = data.kind === "email";

  const handleCopy = async () => {
    const text = isEmail && variant.subject
      ? `Subject: ${variant.subject}\n\n${variant.body}`
      : variant.body;
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="tool-message-compose">
      <div className="tmc-header">
        <div className="tmc-header-icon">
          {isEmail ? <Mail size={16} /> : <MessageSquare size={16} />}
        </div>
        <span className="tmc-title">{data.summary_title}</span>
      </div>

      {data.variants.length > 1 && (
        <div className="tmc-variants">
          {data.variants.map((v, i) => (
            <button
              key={i}
              className={`tmc-variant-btn${activeVariant === i ? " active" : ""}`}
              onClick={() => setActiveVariant(i)}
            >
              {v.label}
            </button>
          ))}
        </div>
      )}

      <div className="tmc-body">
        {isEmail && variant.subject && (
          <div className="tmc-subject">
            <span className="tmc-subject-label">Emne:</span>
            <span className="tmc-subject-text">{variant.subject}</span>
          </div>
        )}
        <div className="tmc-content">{variant.body}</div>
      </div>

      <div className="tmc-footer">
        <button className="tmc-copy-btn" onClick={handleCopy}>
          {copied ? (
            <><Check size={14} /> Kopiert</>
          ) : (
            <><Copy size={14} /> Kopier</>
          )}
        </button>
        {isEmail && (
          <button
            className="tmc-open-btn"
            onClick={() => {
              const mailto = `mailto:?subject=${encodeURIComponent(variant.subject || "")}&body=${encodeURIComponent(variant.body)}`;
              window.open(mailto);
            }}
          >
            <Mail size={14} /> Åpne i e-post
          </button>
        )}
      </div>
    </div>
  );
}
